/**
 * @author Jafar Amini in March 2018.
 */
export enum ResponseContentType {
  Json,
  Text,
  Blob,
  ArrayBuffer
}
